
import React, {createRef} from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto} from "../Configuracion";
import PropTypes from "prop-types";
import Titulo from "../../framework2/ej2/UI/Titulo";
import SignaturePad from 'signature_pad';
import {loadDatos, renderFormulario, renderGrid} from "../utils/FormularioUtils";
import Cita from "../citas/Cita";
import {
    CELLTIPO_CADENA,
    CELLTIPO_FECHA,
    CELLTIPO_ICONOACCION,
    COLUMNVISIBLE_SIEMPRE
} from "../../framework2/ej2/UI/TiposCeldas";

class ConsentimientoSeleccionTipo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            cargandoDatos: false,
            consentimientoTipoCodigo: 0,
            datos: [],
        }

        this.columnas= [
            {campo: "M", titulo: "M", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE,
                icon: "edit",
                onAccion: (elemento) => {
                    console.log(elemento);
                    console.log("ON ACEPTAR");
                    console.log("this.props: ", this.props);
                    this.props.onAceptar && this.props.onAceptar(elemento);
                }
            },
            {campo:"nombre", titulo: "Tipo", tipo: CELLTIPO_CADENA, ancho:300,},
        ];

    }

    componentDidMount() {
        this.loadDatos();
    }

    loadDatos= () =>{
        let parametros= {  }
        console.log("LOAD DATOS ");
        console.log("parametros: ", parametros);

        loadDatos(this, "Consentimientotipo");
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onCancelar= () => {
        const {onCancelar} = this.props;
        console.log ("ConsentiminetoSeleccionTipo - onCAncelar");
        onCancelar && onCancelar();
    }



    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------


    render() {
        const {showGrid, datos} = this.state;
        let propiedadesGrid= {mostrarBotonera: false, mostrarEliminar: false, height: 200};

        return (
            <div style={{margin: 8, padding: 4}}>
                {/*<Titulo titulo=". Selección de Consentimiento" soloTitulo={true}/> */}
                {renderGrid(this, "Tipos de consentimientos", datos, this.onAccion, propiedadesGrid)}

                <div style={{ marginTop: 10 }}>
                    <button onClick={this.onCancelar}>Cancelar</button>
                </div>
            </div>
        )

    }

}

ConsentimientoSeleccionTipo.propTypes = {
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(ConsentimientoSeleccionTipo);



